<header>
  <svg class="icon">
    <use [attr.xlink:href]="'/assets/images/issue-actions/sprite.svg#'+action.type+'-Thick'"></use>
  </svg>
  <h3><strong>{{ action.type | translateEnum: 'actionType' }}</strong></h3>
</header>
<div class="above-the-fold">
  <section class="details">
    <ul class="properties">
      <li *ngIf="action.instructions"><i class="fa fa-info-circle"></i> {{ action.instructions }}</li>
      <li *ngIf="issue?.issueLocationPath"><i class="fa fa-map-marker"></i> <span>{{ issue?.issueLocationPath }} /
        <strong>{{ issue?.issueBuildingLabel }}</strong></span></li>
      <li *ngIf="issue?.buildingAddress || issue?.siteAddress"><i
        class="fa fa-house"></i> {{ issue?.buildingAddress || issue?.siteAddress }}
      </li>
      <li *ngIf="issue?.issueId"><i class="fa fa-hashtag"></i> {{ issue?.issueId }}</li>
    </ul>
  </section>
</div>
<div class="below-the-fold"
#belowTheFold
mdbCollapse>
  <section class="details">
    <ul class="properties">
      <li *ngIf="issue?.issueTitle"><i class="fa fa-info-circle"></i> {{ issue?.issueTitle }}</li>
      <li *ngIf="action.workOrderReference"><i class="fa fa-briefcase"></i> {{ action.workOrderReference }}</li>
      <li *ngIf="action.reference"><i class="fa fa-check"></i> {{ action.reference }}</li>
      <li *ngIf="action.dueDate"><i class="fa fa-calendar"></i> {{ action.dueDate | date: config.DATE_FORMAT }}</li>
      <li *ngIf="issue?.issueCategory">
        <svg class="sprite icon">
          <use xlink:href="#squares"></use>
        </svg>
        {{ issue?.issueCategory | translateEnum: 'issueCategoryType' }}
      </li>
    </ul>
  </section>
  <section class="media">
    <chapps-multimedium *ngFor="let photo of actionMedia"
                        [model]="photo"
                        [showDate]="true"
                        [dateFormat]="config.DATE_TIME_FORMAT"
                        (click)="openMediaViewer(photo, actionMedia)"></chapps-multimedium>
  </section>
</div>
<button class="collapse-toggle"
        (click)="toggleDetails()">
  <span *ngIf="!showDetails">Show more</span>
  <span *ngIf="showDetails">Show less</span>
  <i class="fa fa-chevron-down"></i>
</button>
